import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// ─── Firebase Config ──────────────────────────────────────────────
// Replace these values with your actual Firebase project config.
// Get them from: Firebase Console → Project Settings → Your Apps → Web app
const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY            ?? '',
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN        ?? '',
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID         ?? '',
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET     ?? '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? '',
  appId:             process.env.REACT_APP_FIREBASE_APP_ID             ?? '',
};

const app = initializeApp(firebaseConfig);

export const auth      = getAuth(app);
export const db        = getFirestore(app);
export const functions = getFunctions(app, 'europe-west1'); // closest to Spain

// ─── Local emulator (dev only) ────────────────────────────────────
if (process.env.REACT_APP_USE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

export default app;
